import { render } from "./HafezliLessons.vue?vue&type=template&id=68bd93ca&scoped=true"
import script from "./HafezliLessons.vue?vue&type=script&lang=js"
export * from "./HafezliLessons.vue?vue&type=script&lang=js"

import "./HafezliLessons.vue?vue&type=style&index=0&id=68bd93ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68bd93ca"]])

export default __exports__